import React from 'react';
import { FormattedMessage } from 'react-intl';
import OnlineOnboardingStepperSC from './online-onboarding-stepper.styled.js';

const OnlineOnboardingStepper = ({ currentStep, insured = true }) => {
  // Definícia všetkých krokov v správnom poradí
  const steps = [
    {
      key: 'id-card',
      labelId: 'online_onboarding_stepper_id_card',
      defaultLabel: 'Overenie totožnosti'
    },
    {
      key: 'ocr',
      labelId: 'online_onboarding_stepper_ocr',
      defaultLabel: 'Overenie údajov'
    },
    {
      key: 'income-docs',
      labelId: 'online_onboarding_stepper_income_docs',
      defaultLabel: 'Dokumenty o príjmoch'
    },
    {
      key: 'waiting-for-confirmation',
      labelId: 'online_onboarding_stepper_waiting_confirmation',
      defaultLabel: 'Potvrdzovanie žiadosti'
    },
    {
      key: 'get-loan-documentation',
      labelId: 'online_onboarding_stepper_loan_documentation',
      defaultLabel: 'Dokumentácia úveru'
    },
    {
      key: 'get-insurance-documentation',
      labelId: 'online_onboarding_stepper_insurance_documentation',
      defaultLabel: 'Dokumentácia poistenia'
    },
    {
      key: 'waiting-for-documents-check',
      labelId: 'online_onboarding_stepper_waiting_documents_check',
      defaultLabel: 'Kontrola dokumentov'
    },
    {
      key: 'online-loan-finished',
      labelId: 'online_onboarding_stepper_online_loan_finished',
      defaultLabel: 'Ukončenie'
    }
  ];

  // Zistenie indexu aktuálneho kroku
  const currentStepIndex = steps.findIndex(step => step.key === currentStep);

  // Krok poistenia považujeme za preskočený ak sme na konci a insured je false
  const skipInsurance = currentStep === 'online-loan-finished' && insured === false;

  // Funkcia na určenie, či má byť krok viditeľný na mobile
  const shouldShowOnMobile = (index) => {
    const firstIndex = 0;
    const lastIndex = steps.length - 1;

    // Vždy zobraz prvý, aktuálny a posledný krok
    return index === firstIndex || index === currentStepIndex || index === lastIndex;
  };

  // Funkcia na vykreslenie bodiek medzi krokmi
  const renderDots = (position) => {
    return (
      <div className="dots-indicator mobile-only">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    );
  };

  return (
    <OnlineOnboardingStepperSC>
      <div className="stepper-container">
        {steps.map((step, index) => {
          let status;
          if (index < currentStepIndex) {
            status = 'completed';
          } else if (index === currentStepIndex) {
            status = 'active';
          } else {
            status = 'pending';
          }

          if (step.key === 'get-insurance-documentation' && skipInsurance) {
            status = 'skipped';
          }

          const isLast = index === steps.length - 1;
          const showOnMobile = shouldShowOnMobile(index);

          // Zistíme, či treba zobraziť bodky pred týmto krokom
          const showDotsBeforeOnMobile =
            index === currentStepIndex && currentStepIndex > 1;

          // Zistíme, či treba zobraziť bodky za týmto krokom
          const showDotsAfterOnMobile =
            index === currentStepIndex && currentStepIndex < steps.length - 2;

          return (
            <React.Fragment key={step.key}>
              {showDotsBeforeOnMobile && renderDots('before')}

              <div className={`step-wrapper ${!showOnMobile ? 'mobile-hidden' : ''}`}>
                <div className={`step ${status}`}>
                  <div className="step-circle">
                    {status === 'completed' ? (
                      <svg width="12" height="9" viewBox="0 0 12 9" fill="none" aria-hidden>
                        <path
                          d="M1 4.5L4.5 8L11 1"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : status === 'skipped' ? (
                      <span className="skip-icon" aria-hidden>↷</span>
                    ) : (
                      <span className="step-number">{index + 1}</span>
                    )}
                  </div>
                  <div className="step-label">
                    <FormattedMessage
                      id={step.labelId}
                      defaultMessage={step.defaultLabel}
                    />
                  </div>
                </div>
                {!isLast && <div className={`step-connector ${status === 'completed' ? 'completed' : ''}`} />}
              </div>

              {showDotsAfterOnMobile && renderDots('after')}
            </React.Fragment>
          );
        })}
      </div>
    </OnlineOnboardingStepperSC>
  );
};

export default OnlineOnboardingStepper;
